export const AUTH_USER_TYPES = {
  SYSTEM: "system",
  TENANT: "tenant",
};

export const AUTH_STORAGE_KEY = "idp_auth_session";
